import { MaskedLine, FadeUp, Page, Meta } from "../components/Reveal";
import { useContent } from "../lib/ContentContext";

function SectionList({ keys, prefix, c }) {
  return (
    <div className="mt-14 space-y-0">
      {keys.map((k, i) => (
        <FadeUp key={k} delay={0.04 * i}>
          <div data-testid={`${prefix}-section-${i + 1}`} className="grid gap-3 border-t border-linen py-10 md:grid-cols-12 md:gap-8">
            <h2 className="font-serif text-2xl font-light leading-snug tracking-tight md:col-span-4">
              {c(`${k}.titre`)}
            </h2>
            <p className="text-sm leading-loose text-smoke md:col-span-8 md:text-base">
              {c(`${k}.texte`)}
            </p>
          </div>
        </FadeUp>
      ))}
    </div>
  );
}

const PRIVACY_KEYS = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => `confidentialite.p${n}`);
const LEGAL_KEYS = [1, 2, 3, 4, 5].map((n) => `confidentialite.l${n}`);

export default function Confidentialite() {
  const c = useContent();
  return (
    <Page testId="confidentialite-page">
      <section className="mx-auto max-w-7xl px-6 pt-36 md:px-12 md:pt-48">
        <FadeUp><Meta>{c("confidentialite.hero.meta")}</Meta></FadeUp>
        <h1 className="mt-6 max-w-4xl font-serif text-5xl font-light leading-[1.08] tracking-tight md:text-7xl">
          <MaskedLine delay={0.2}>{c("confidentialite.hero.l1")}</MaskedLine>
          <MaskedLine delay={0.35} className="italic text-clay">{c("confidentialite.hero.l2")}</MaskedLine>
        </h1>
        <FadeUp delay={0.5} className="mt-10 max-w-2xl">
          <p className="text-base leading-relaxed text-smoke md:text-lg">
            {c("confidentialite.hero.p")}
          </p>
        </FadeUp>
        <SectionList keys={PRIVACY_KEYS} prefix="privacy" c={c} />
      </section>

      <section id="mentions-legales" className="mx-auto max-w-7xl scroll-mt-32 px-6 py-24 md:px-12 md:py-32">
        <FadeUp><Meta>{c("confidentialite.legal.meta")}</Meta></FadeUp>
        <h2 className="mt-6 font-serif text-4xl font-light leading-[1.12] tracking-tight md:text-5xl">
          {c("confidentialite.legal.t1")} <em className="text-clay">{c("confidentialite.legal.t2")}</em>
        </h2>
        <SectionList keys={LEGAL_KEYS} prefix="legal" c={c} />
        <FadeUp delay={0.1}>
          <p className="mt-14 rounded-[1.75rem] bg-sage/40 p-8 text-sm leading-relaxed text-smoke md:p-10 md:text-base">
            {c("confidentialite.fin.texte")}{" "}
            <a href="mailto:contact@eugenielarrivee.com" data-testid="privacy-contact-link"
              className="text-clay underline-offset-4 transition-colors duration-300 hover:underline">
              contact@eugenielarrivee.com
            </a>
          </p>
        </FadeUp>
      </section>
    </Page>
  );
}
